import { render, staticRenderFns } from "./FormProgramChanges.vue?vue&type=template&id=4e8b122b&"
import script from "./FormProgramChanges.vue?vue&type=script&lang=js&"
export * from "./FormProgramChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports